// Live growth-situation pages from the CMS (/api/situations), with the static
// SITUATIONS as a graceful fallback.
import { useState, useEffect } from "react";
import { SITUATIONS } from "./situations";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _promise = null;

export const invalidateSituations = () => { _cache = null; _promise = null; };

export const loadSituations = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/situations`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((d) => {
        const map = {};
        (d.situations || []).forEach((s) => { map[s.slug] = s; });
        _cache = Object.keys(map).length ? map : SITUATIONS;
        return _cache;
      })
      .catch(() => { _cache = SITUATIONS; return SITUATIONS; });
  }
  return _promise;
};

export const useSituation = (slug) => {
  const [state, setState] = useState(() => {
    const c = _cache && _cache[slug];
    return { loading: !c, data: c || null };
  });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    fetch(`${API}/situations/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive) setState({ loading: false, data: d || SITUATIONS[slug] || null }); })
      .catch(() => { if (alive) setState({ loading: false, data: SITUATIONS[slug] || null }); });
    return () => { alive = false; };
  }, [slug]);
  return state;
};

export const useSituations = () => {
  const [list, setList] = useState(_cache ? Object.values(_cache) : Object.values(SITUATIONS));
  useEffect(() => {
    let alive = true;
    loadSituations().then((m) => alive && setList(Object.values(m)));
    return () => { alive = false; };
  }, []);
  return list;
};
